import log from 'loglevel'
import { FlowlineCompositeLayer } from '@/js/custom-layers/FlowlineCompositeLayer.js'
import { DataFilterExtension } from '@deck.gl/extensions'

// レイヤーID
const LAYER_ID = 'flowline'

/**
 * 動線強調マップのレンダラー
 */
class FlowlineRenderer {
  /**
   * レイヤーID
   * @returns {String}
   */
  static LAYER_ID() {
    return LAYER_ID
  }

  /**
   * コンストラクタ
   */
  constructor() {}

  /**
   * レンダラー関数を作成する
   * @param {Object|Function} data 描画するデータ
   * @param {Object} props 追加・上書きprops
   * @returns {Object} レンダラー {id: String, render: Function.<Layer>}
   */
  createRenderer(data, props) {
    log.debug('FlowlineRenderer create', data, props)
    return {
      id: LAYER_ID,
      render: () =>
        new FlowlineCompositeLayer({
          id: LAYER_ID,
          data: typeof data === 'function' ? data() : data,
          extensions: [new DataFilterExtension({ filterSize: 1 })],
          ...props,
        }),
    }
  }
}

FlowlineRenderer.LAYER_ID = LAYER_ID

export default FlowlineRenderer
